export const MP_SOURCE_COMPONENT = 'Gig page contact seller button';
export const BQ_SOURCE_NAME = 'contact_seller';
export const ARROW_SIZE = 12;
